import * as R from 'ramda';

import naturalSort from '@atom/utilities/naturalSortCollator';

const DEFAULT_COLOR = 0;

// Keys correspond to the colorId / markerId value of schema and assets.
// Additionally, the keys match the index order for rendering options in UI.
export const colors = {
  0: '#00BCD4',
  1: '#509DE9',
  2: '#4EBFD8',
  3: '#69D7C8',
  4: '#999CFF',
  5: '#B99AFF',
  6: '#F690B2',
  7: '#9209AE',
  8: '#7F57C2',
  9: '#4A18BD',
  10: '#1D905B',
  11: '#31CA82',
  12: '#7BD148',
  13: '#B3DD6B',
  14: '#DBDF5F',
  15: '#ECCE31',
  16: '#417505',
  17: '#146495',
  18: '#0048C7',
  19: '#555555',
  20: '#AC715D',
  21: '#D06B63',
  22: '#F93922',
  23: '#FA573B',
  24: '#FF7537',
  25: '#FBC02D',
  26: '#BE681C',
  27: '#8B572A',
  28: '#513838',
  29: '#333333',
  30: '#00BCD4',
  31: '#00A89A',
  32: '#21A567',
  33: '#417505',
  34: '#FF8F00',
  35: '#FFA800',
  36: '#E354B4',
  37: '#7F57C2',
  38: '#0048C7',
  39: '#555555',
  40: '#509DE9',
  41: '#1BBCD7',
  42: '#00A89A',
  43: '#1D905B',
  44: '#BE681C',
  45: '#6B4927',
  46: '#513838',
  47: '#555555',
  48: '#555555',
  49: '#333333',
  50: '#509DE9',
  51: '#F93922',
  52: '#509DE9',
  53: '#7BD148',
  54: '#7BD148',
  55: '#7BD148',
  56: '#509DE9',
  57: '#333333',
  58: '#7BD148',
  59: '#509DE9',
  60: '#509DE9',
  61: '#FBC02D',
  62: '#509DE9',
  63: '#7BD148',
  64: '#FF7537',
  65: '#509DE9',
  66: '#509DE9',
  67: '#FF7537',
  68: '#7BD148',
  69: '#EF410A',
  70: '#509DE9',
  71: '#333333',
  72: '#E354B4',
  73: '#509DE9',
  74: '#F93922',
  75: '#7BD148',
  76: '#509DE9',
  77: '#E354B4',
  78: '#333333',
  79: '#509DE9',
  80: '#333333',
  81: '#417505',
  82: '#509DE9',
  83: '#555555',
  84: '#1D905B',
  85: '#333333',
  86: '#ED3620',
  87: '#7F57C2',
  88: '#FFA800',
  89: '#FF7537',
  90: '#999999',
  91: '#509DE9',
  92: '#FF7537',
  93: '#7BD148',
  94: '#333333',
  95: '#0048C7',
  96: '#B99AFF',
  97: '#333333',
  98: '#0048C7',
  99: '#7BD148',
  100: '#333333',
  101: '#0048C7',
  102: '#FFA800',
  103: '#509DE9',
  104: '#7BD148',
  105: '#FF7537',
  106: '#1BBCD7',
  107: '#1D905B',
  108: '#555555',
  109: '#EF410A',
};

export const getColorFromColorId = colorId => {
  return colors[colorId] || colors[DEFAULT_COLOR];
};

// Produces an ordered list of color swatches to be used in the UI
export const getColorSwatchList = () => {
  return R.sort(naturalSort, R.map(String, R.keys(colors))).map(
    key => colors[key],
  );
};
